<!-- eslint-disable max-len -->
<template>
  <svg width="20"
       height="20"
       viewBox="0 0 20 20"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
       aria-hidden="true">
    <path fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.666672 9.33329H16.8333L11.0833 3.58329L12 2.66663L19.3333 9.99996L12 17.3333L11.0833 16.4166L16.8333 10.6666H0.666672V9.33329Z"
          fill="currentColor" />
  </svg>
</template>

<script setup></script>
